/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';

import {COMMON_DEPRECATED_DIRECTIVES, COMMON_DIRECTIVES} from './directives/index';
import {NgLocaleLocalization, NgLocalization} from './localization';
import {COMMON_PIPES} from './pipes/index';
/**
 * The module that includes all the basic Angular directives like {\@link NgIf}, {\@link NgForOf}, ...
 * 
 * \@stable
 */
export class CommonModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [COMMON_DIRECTIVES, COMMON_PIPES],
  exports: [COMMON_DIRECTIVES, COMMON_PIPES],
  providers: [
    {provide: NgLocalization, useClass: NgLocaleLocalization},
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CommonModule_tsickle_Closure_declarations() {
/** @type {?} */
CommonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CommonModule.ctorParameters;
}

/**
 * I18N pipes are being changed to move away from using the JS Intl API.
 * 
 * The former pipes relying on the Intl API will be moved to this module while the `CommonModule`
 * will contain the new pipes that do not rely on Intl.
 * 
 * As a first step this module is created empty to ease the migration.
 * 
 * see https://github.com/angular/angular/pull/18284
 * 
 * @deprecated from v5
 */
export class DeprecatedI18NPipesModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{declarations: [], exports: []}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DeprecatedI18NPipesModule_tsickle_Closure_declarations() {
/** @type {?} */
DeprecatedI18NPipesModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DeprecatedI18NPipesModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/common/src/common_module.ts